import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { MatDialog } from '@angular/material';
import { LoaderComponent } from './Common/Components/Loader/loader.component';

@Injectable()
export class AppService {

  loading$: Observable<boolean> = of(false);

  constructor(public dialog: MatDialog) { }

  fireLoader() {

    setTimeout(() => {

      if (this.dialog.getDialogById('ecoloader') == null)
      {
        this.dialog.open(LoaderComponent, {
            id:'ecoloader',
            width: '255px',
            data: '',
            disableClose: true
        });
      }
    }, 500);

    //this.loading$ = of(true);
    
  }

  stopLoader() {
    setTimeout(() => {
      if (this.dialog.getDialogById('ecoloader') != null)
      {
        this.dialog.getDialogById('ecoloader').close();
      }
    }, 500);
    
    //this.loading$ = of(false);
  }
  
  private subject = new Subject<any>();

  toggle$ = this.subject.asObservable()

  changeProvider(){
    this.subject.next();
  }

}